import { sizes } from '@/utils'

import dot from '@/components/services/report-manager/commons/timeline/dot'
import tag from '@/components/tag'

const baseClass = 'timeline'

function renderTrack(h, isLast) {
  if (isLast) {
    return null
  }

  return h(
    'div',
    {
      class: `${baseClass}__track`
    }
  )
}

function renderDate(h, point) {
  if (!point.event.date) {
    return null
  }

  return h(
    tag,
    {
      props: {
        label: point.event.date,
        size: sizes.small,
        color: this.getPointColor(point)
      }
    }
  )
}
function renderLabel(h, point) {
  if (!point.event.label) {
    return null
  }

  return h(
    'div',
    {
      class: `${baseClass}__label`,
      domProps: { innerHTML: point.event.label }
    }
  )
}
function renderInfo(h, point) {
  return h(
    'div',
    {
      class: `${baseClass}__info`
    },
    [
      renderDate.call(this, h, point),
      renderLabel.call(this, h, point)
    ]
  )
}
function renderDot(h, point) {
  return h(
    dot,
    {
      props: {
        icon: this.getPointIcon(point),
        color: this.getPointColor(point)
      }
    }
  )
}
function renderPoint(h, point, index) {
  const isLast = index === this.timelinePoints.length - 1

  return h(
    'div',
    {
      class: `${baseClass}__point`
    },
    [
      renderTrack.call(this, h, isLast),
      renderDot.call(this, h, point),
      renderInfo.call(this, h, point)
    ]
  )
}
function renderPoints(h) {
  return h(
    'div',
    {
      class: `${baseClass}__points`
    },
    [
      this.timelinePoints.map((point, index) => {
        return renderPoint.call(this, h, point, index)
      })
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: baseClass
    },
    [ renderPoints.call(this, h) ]
  )
}
